import React, { useEffect, useState } from 'react';
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { quantityIncrementDenomination } from '../../../store/productDetails/action';

const QuantityHandle = ({ denominationData }) => {
  const [quantity, setQuantity] = useState(denominationData?.QUANTITY || 0);
  const dispatch = useDispatch();

  const maxLimit = denominationData?.MAX_LIMIT || 5;

  // Sync quantity with Redux when it changes
  useEffect(() => {
    dispatch(quantityIncrementDenomination(denominationData.AMOUNT, quantity, denominationData.DISCOUNT));
  }, [dispatch, denominationData.AMOUNT, quantity]);

  const handleIncrement = () => {
    if (quantity < maxLimit) {
      setQuantity((prevState) => prevState + 1);
    }
  };

  const handleDecrement = () => {
    if (quantity > 0) {
      setQuantity((prevState) => prevState - 1);
    }
  };

  return (
    <React.Fragment>
      <RemoveRoundedIcon
        className='product__denomination_quantity_icon'
        onClick={handleDecrement}
        sx={{ width: { xs: 16, sm: '16px' } }}
      />

      <Typography sx={{
        maxWidth: "40px",
        fontSize: { xs: "11.5px", sm: ".9rem", lg: "1rem" },
        color: "textPrimary.main1",
        fontWeight: { xs: 700, sm: 700, lg: 700 }
      }}>
        {quantity}
      </Typography>

      <AddRoundedIcon
        className='product__denomination_quantity_icon'
        onClick={handleIncrement}
        sx={{ width: { xs: 16, sm: '16px' } }}
      />
    </React.Fragment>
  );
};

export default QuantityHandle;
